import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './pages/HomePage.vue'
import TermsPage from './pages/TermsPage.vue'
import PrivacyPage from './pages/PrivacyPage.vue'
import BillingTermsPage from './pages/BillingTermsPage.vue'
import RefundPolicyPage from './pages/RefundPolicyPage.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      meta: { title: 'myVPS — быстрый и защищённый доступ к интернету через собственные VPS серверы' }
    },
    {
      path: '/documents/terms',
      name: 'terms',
      component: TermsPage,
      meta: { title: 'Оферта — myVPS' }
    },
    {
      path: '/documents/privacy',
      name: 'privacy',
      component: PrivacyPage,
      meta: { title: 'Политика обработки персональных данных — myVPS' }
    },
    {
      path: '/documents/billing-terms',
      name: 'billingTerms',
      component: BillingTermsPage,
      meta: { title: 'Условия оплаты — myVPS' }
    },
    {
      path: '/documents/refund-policy',
      name: 'refundPolicy',
      component: RefundPolicyPage,
      meta: { title: 'Правила возврата — myVPS' }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.afterEach((to) => {
  if (to.meta.title) document.title = to.meta.title
})

export default router
